import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=544cf08e&lang=pug&"
import script from "./spinner.vue?vue&type=script&lang=js&"
export * from "./spinner.vue?vue&type=script&lang=js&"
import style0 from "./spinner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('544cf08e')) {
      api.createRecord('544cf08e', component.options)
    } else {
      api.reload('544cf08e', component.options)
    }
    module.hot.accept("./spinner.vue?vue&type=template&id=544cf08e&lang=pug&", function () {
      api.rerender('544cf08e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/spinner.vue"
export default component.exports